'use client';

import { Auth0Provider } from '@auth0/nextjs-auth0/client';
import { PropsWithChildren } from 'react';
import { AuthProviderContextProvider } from '../auth-provider-context';

type AuthProviderProps = PropsWithChildren;

/**
 * AuthProvider component that wraps the Auth0Provider.
 * It determines the redirect URI based on the current window's location, if available.
 * This component is typically used to wrap the root component of your application
 * and provides an authentication context for Auth0.
 *
 * @param {AuthProviderProps} props - The props to pass to the Auth0Provider.
 * @returns {React.ReactElement} - The UserProvider component with children
 *
 * @example
 * <AuthProvider>
 *   <App />
 * </AuthProvider>
 */
export function AuthProvider(props: AuthProviderProps) {
  const { children } = props;

  return (
    <AuthProviderContextProvider>
      <Auth0Provider>{children}</Auth0Provider>
    </AuthProviderContextProvider>
  );
}
